import { notifications } from '@mantine/notifications';
import { IconCheck, IconExclamationCircle } from '@tabler/icons-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Endpoints } from '../../apis';
import { getErrorMessage } from '@xver/utils/error';

interface Vars {
    id: number;
    backupId: number;
}

export function useRestoreBackupMutate() {
    const { t } = useTranslation('notifications');
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ id, backupId }: Vars) => Endpoints.v1.Backups.restoreBackup(id, backupId),
        onSuccess: (_data, variables) => {
            queryClient.invalidateQueries({ queryKey: ['api.v1.backups.list', variables.id] });
            queryClient.invalidateQueries({ queryKey: ['api.v1.instances.get', variables.id] });
            notifications.show({
                title: t('backup.restoreStartedTitle'),
                message: t('backup.restoreStartedMessage'),
                icon: <IconCheck size={32} color={'#00ff00'} />,
            });
        },
        onError: (error: any) => {
            notifications.show({
                title: t('backup.restoreFailedTitle'),
                message: getErrorMessage(error),
                icon: <IconExclamationCircle size={32} color={'#eb5757'} />,
            });
        },
    });
}
